type SubscriptionPlan = 'free' | 'basic' | 'boost' | 'secure' | 'premium';

const CANONICAL_PLANS: SubscriptionPlan[] = ['free', 'basic', 'boost', 'secure', 'premium'];

const normalizePlanValue = (value: unknown): SubscriptionPlan | null => {
  if (typeof value !== 'string') {
    return null;
  }

  let normalized = value.trim().toLowerCase().replace(/[\s-]+/g, '_');

  if (normalized === 'public') normalized = 'boost';
  if (normalized === 'privacy') normalized = 'secure';
  if (normalized === 'all_enabled' || normalized === 'allenabled') normalized = 'premium';

  return CANONICAL_PLANS.includes(normalized as SubscriptionPlan) ? (normalized as SubscriptionPlan) : null;
};

const isPublicPlan = (plan: SubscriptionPlan | null | undefined): boolean =>
  plan === 'boost' || plan === 'premium';

const isPrivacyPlan = (plan: SubscriptionPlan | null | undefined): boolean =>
  plan === 'secure' || plan === 'premium';

const isPaidPlan = (plan: SubscriptionPlan | null | undefined): boolean =>
  plan === 'basic' || plan === 'boost' || plan === 'secure' || plan === 'premium';

export { normalizePlanValue, isPublicPlan, isPrivacyPlan, isPaidPlan };
export type { SubscriptionPlan };
